var singleDigitRegex = /\d/;
var notDigitRegex = /[^\d]/g;
var leadingZeroesRegex = /^0+([1-9]+\d*)/;
var thousandPlacesRegex = /\B(?=(\d{3})+(?!\d))/g;
var onlyZerosRegex = /^0+$/;

var getCursorPos = function getCursorPos(val, posInValue, symbolLength) {
  var i = 0;
  var cursorPos = 0;
  var len = val.length;

  while (i < posInValue && cursorPos < len) {
    if (singleDigitRegex.test(val.charAt(cursorPos))) {
      i++;
    }

    cursorPos++;
  }

  return Math.max(symbolLength + 1, cursorPos);
};

var format = function format(value, props) {
  var output = value.trim();
  output = output.replace(thousandPlacesRegex, props.thousandSeparator);
  output = "".concat(props.symbol, " ").concat(output);
  return output;
};

var unformat = function unformat(value) {
  var output = value.replace(notDigitRegex, '');
  output = output.replace(leadingZeroesRegex, '$1');
  output = output.replace(onlyZerosRegex, '0');
  return output;
};

var getFormattedLength = function getFormattedLength(digits, symbol) {
  if (typeof digits !== 'number' || !digits) {
    return digits;
  }

  return digits + ((digits - 1) / 3 | 0) + symbol.length + 1;
};

export { format, getCursorPos, getFormattedLength, unformat };